import { IconButton, MenuItem, MenuItemProps, Select, SelectProps } from '@mui/material';
import { useAppTranslation } from '@/infrastructure/hooks/useAppTranslation';
import CloseIcon from '@mui/icons-material/Close';

type Props = Omit<SelectProps, 'children' | 'onChange'> & {
  children: React.ReactNode;
  clearable?: boolean;
  showNoneOption?: boolean;
  onChange?: (value: string) => void;
};

export const LtSelect = ({
  children,
  clearable = false,
  showNoneOption = false,
  onChange,
  ...rest
}: Props) => {
  const { t } = useAppTranslation();

  return (
    <Select
      onChange={e => onChange?.(e.target.value as string)}
      {...rest}
      endAdornment={
        clearable && rest.value ? (
          <IconButton sx={{ mr: 1.6 }} onClick={() => onChange?.('')}>
            <CloseIcon fontSize='small' />
          </IconButton>
        ) : undefined
      }
    >
      {showNoneOption && (
        <MenuItem value=''>
          <em>{t('none')}</em>
        </MenuItem>
      )}
      {children}
    </Select>
  );
};

export type LtSelectOptionProps = MenuItemProps;

export const LtSelectOption = MenuItem;
